<template>
  <div class="container">
        <div class="page-bar py-3 my-3">
          <div class="container">
            <div class="d-flex align-items-center">
              <BackButton class="btn btn-link p-0 mr-2" fallback="/host">
                <i class="fas fa-chevron-left"></i>
              </BackButton>
              <div class="page-title flex-grow-1">{{ businessName || 'Business Name' }} Profile</div>
             </div>
          </div>
        </div>
    <div class="vendor-profile card shadow-sm overflow-hidden">

      <!-- Cover + Avatar -->
      <div class="cover-wrap position-relative">
        <img v-no-right-click :src="coverUrl" class="cover-img w-100" alt="business cover" />
        <img v-no-right-click :src="avatarUrl" class="avatar-img rounded-circle shadow" alt="business logo" />
      </div>

      <!-- Body -->
      <div class="p-3 p-md-4">
        <h1 class="business-title h4 mb-2 mt-4">{{ businessName || 'Business Name' }}</h1>

        <!-- URL -->
        <p class="mb-2" v-if="websiteHref">
          <a :href="websiteHref" target="_blank" rel="noopener" class="small text-primary">
            {{ websiteHref }}
          </a>
        </p>

        <!-- Meta row -->
        <div class="d-flex flex-wrap align-items-center text-muted small mb-3">
          <span class="mr-3">
            <i class="fas fa-briefcase mr-1"></i>{{ businessCategory }}
          </span>
          <span class="mr-3" v-if="followers">
            <i class="fas fa-users mr-1"></i>{{ followers }} Followers
          </span>
          <span class="mr-3" v-if="locationText">
            <i class="fas fa-map-marker-alt mr-1"></i>{{ locationText }}
          </span>
            <span 
            class="badge border ml-md-1 mt-2 py-1 mt-md-0" 
            :class="{
                'badge-success': openInfo == 1,
                'badge-danger': openInfo == 0
            }"
            v-if="openInfo !== null">
            <i class="far fa-clock mr-1"></i>{{ openStatus }}
            </span>

        </div>
        <p class="mb-2 mt-2">{{ deliveryMethods }}</p>


        <!-- Action buttons: horizontally scrollable -->
        <div class="action-scroll mb-3">
          <button type="button" class="btn btn-outline-primary mr-2 px-3 py-1"
                  @click="openLink(orderLink)" :disabled="!orderLink">
            Order Online
          </button>
          <button type="button" class="btn btn-outline-primary mr-2 px-3 py-1"
                  @click="openLink(telegramLink)" :disabled="!telegramLink">
            Telegram
          </button>
          <button type="button" class="btn btn-outline-primary mr-2 px-3 py-1"
                  @click="openLink(whatsappLink)" :disabled="!whatsappLink">
            Chat on WhatsApp
          </button>
          <button type="button" class="btn btn-outline-primary mr-2 px-3 py-1"
                  @click="callPhone" v-if="phone">
            Call
          </button>
          <button type="button" class="btn btn-outline-primary px-3 py-1"
                  @click="sendEmail" v-if="email">
            Email
          </button>
        </div>

        <!-- Custom Tabs -->
        <div class="custom-tabs">
          <div class="tabs-bar d-flex flex-nowrap">
            <button v-for="t in tabs" :key="t.key" type="button"
                    class="tab-btn" :class="{ active: currentTab === t.key }"
                    @click="currentTab = t.key">
              {{ t.label }}
            </button>
          </div>

          <div class="tab-panel mt-3">
            <!-- Overview -->
            <div v-show="currentTab === 'overview'">
              <div class="container-fluid">
                <div class="mb-2 font-weight-bold">About the Business</div>
                <p class="mb-3" v-if="aboutText">{{ aboutText }}</p>

                <div class="row">
                  <div class="col-sm-6 mb-2" v-if="phone">
                    <div class="info-chip">
                      <i class="fas fa-phone mr-2 text-primary"></i>{{ phone }}
                    </div>
                  </div>
                  <div class="col-sm-6 mb-2" v-if="email">
                    <div class="info-chip">
                      <i class="fas fa-envelope mr-2 text-primary"></i>{{ email }}
                    </div>
                  </div>
                  <div class="col-12 mb-2" v-if="address">
                    <div class="info-chip">
                      <i class="fas fa-map-marker-alt mr-2 text-primary"></i>{{ address }}
                    </div>
                  </div>
                </div>

                <!-- Images gallery -->
                <div class="mt-3" v-if="images.length">
                <hr>
                  <div class="mb-1 font-weight-bold">Photos</div>
                  <div class="row no-gutters">
                    <div class="col-4 col-md-3 p-1" v-for="(img, idx) in images" :key="idx">
                      <div class="img-thumb-wrap">
                       <a :href="img.simg_img" data-fancybox="Business Image"> <img v-no-right-click :src="img.simg_img" class="img-fluid rounded" alt="Business image" /></a>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="mt-3" v-if="selectedCategories.length">
                <hr>
                  <div class="mb-1 font-weight-bold">Categories</div>
                  <div class="row">
                    <div class="col-md-6">
                      <ul class="list-unstyled mb-0">
                        <li v-for="(svc, i) in leftServices" :key="'l'+i" class="mb-2">
                          <i class="fas fa-check-circle text-primary mr-2"></i>{{ svc }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6 mt-2 mt-md-0">
                      <ul class="list-unstyled mb-0">
                        <li v-for="(svc, i) in rightServices" :key="'r'+i" class="mb-2">
                          <i class="fas fa-check-circle text-primary mr-2"></i>{{ svc }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- Products Tab -->
            <div v-show="currentTab === 'products'">
            <div v-if="productsLoading" class="text-muted small">Loading products…</div>

            <div v-else-if="!categories.length" class="text-center">
                <img
                src="https://dummyimage.com/100x100/ccc/222.png&text=No+Products"
                alt="no products"
                class="img-fluid rounded-circle mb-2"
                />
                <p class="mt-2 mb-0 text-muted">No Products Found</p>
            </div>

            <div v-else>
                <!-- Scrollable pill menu -->
                <div class="cat-bar mb-3">
                <div class="cat-track" ref="catTrack">
                    <!-- All pill -->
                    <button
                    type="button"
                    class="cat-pill"
                    :class="{ active: selectedCategory === 'All' }"
                    @click="showAllProducts"
                    >
                    <span>All</span>
                    <span class="count-badge">{{ allCount }}</span>
                    </button>

                    <!-- Category pills -->
                    <button
                    v-for="(cat, i) in categories"
                    :key="i"
                    type="button"
                    class="cat-pill"
                    :class="{ active: selectedCategory === cat.name }"
                    @click="filterByCategory(cat.name)"
                    >
                    <span>{{ cat.name }}</span>
                    <span class="count-badge">{{ cat.products.length }}</span>
                    </button>
                </div>
                </div>

                <!-- Grid -->
                <h6 class="font-weight-bold mb-3 text-primary">
                {{ selectedCategory }} <span class="text-muted small">({{ products.length }})</span>
                </h6>

                <div v-if="!products.length" class="text-center py-5 text-muted small border rounded">
                No Products in this Category
                </div>

                <div v-else class="row">
                <div class="col-6 col-md-4 mb-3" v-for="(p, i) in products" :key="i">
                    <div class="card h-100 shadow-sm border-0" v-if="p.hide == 0">
                    <img
                        :src="p.image"
                        class="card-img-top"
                        style="height: 160px; object-fit: cover"
                        alt="product"
                    />
                    <div class="card-body p-2">
                        <div class="font-weight-semibold small text-dark mb-1">
                        {{ p.title }}
                        </div>
                        <div class="small text-muted mb-1" v-if="p.price">
                        {{ p.currency }}{{ p.price }}
                        </div>
                        <div class="text-secondary small d-none text-truncate-2" v-if="p.description">
                        {{ p.description }}
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>



            <!-- Services (full list as fallback) -->
            <div v-show="currentTab === 'services'">
              <div class="row" v-if="allCategories.length">
                <div class="col-md-6">
                  <ul class="mb-0 pl-3 list-group">
                    <li class="list-group-item"
                        v-for="(c, i) in allCategories" :key="i">
                      <i class="fas fa-check-circle text-primary mr-2"></i>{{ c.name }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-else class="text-center"><img v-no-right-click src="https://dummyimage.com/100x100/222/222.png" alt="" class="img-fluid rounded-circle"> <p class="mt-2 mb-0">No Services Found</p></div>
            </div>
          </div> <!-- /tab-panel -->
        </div> <!-- /custom-tabs -->
      </div>

    </div>
  </div>
</template>


<script setup>
import { ref, computed, onMounted, watch, watchEffect } from "vue";
import { useRoute, onBeforeRouteUpdate } from "vue-router";
import api from "@/services/api";
import { useSessionStore } from "@/stores/session";
import BackButton from '@/components/common/BackButton.vue'

/* -------------------------
   State & route handling
------------------------- */
const route = useRoute();
const session = useSessionStore();

const business = ref({});
const services = ref({});
const loading  = ref(false);

const getBusinessIdFromRoute = (r = route) =>
  r.params?.businessid || (r.path || "").split("/").filter(Boolean).pop() || "";

const routeBusinessId = ref(getBusinessIdFromRoute());

/* businessid to use for downstream APIs (prefer server-provided id) */
const apiBusinessId = ref(""); // filled after businessdetail (slug || s_id || routeBusinessId)

/* -------------------------
   API: businessdetail
------------------------- */
async function loadBusinessDetail() {
  const id = routeBusinessId.value;
  if (!id) return;

  loading.value = true;
  try {
    session.loadUser?.();

    const fd = new FormData();
    fd.append("userid", session.userId || "");
    fd.append("businessid", String(id));

    const res = await api.getBusinessDetail(fd);
    const info = Array.isArray(res?.data?.data) ? res.data.data[0] : null;
    const serviceInfo = Array.isArray(res?.data?.services) ? res.data.services : null;
    if (!info) {
      business.value = {};
      apiBusinessId.value = "";
      return;
    }

    if(!serviceInfo){ 
      services.value = "";
      return;
    }

    // normalize + keep both banner/cover
    const cover_img = info.banner_image || info.cover_image || "";
    business.value = {
      s_id: info.s_id,
      s_business: info.s_business || "",
      s_user_img: info.s_user_img || "",
      cover_img,                // store normalized cover
      banner_image: cover_img,  // keep for template compatibility

      website: info.website_link || "",
      orderonline_link: info.orderonline_link || "",
      telegram_link: info.telegram_link || "",
      whatsapp_link: info.whatsapp_link || "",

      businesscategory: info.businesscategory || info.s_type || "Business",
      followers: Number(info.followcount || 0) || 0,
      city: info.s_city || info.city || "",
      open_status: info.time_status || "",
      open_info: info.time_info || 0,
      deliverymethods: info.delmethods || "",

      s_phone: info.s_phone ? `${info.s_phone_code || ""} ${info.s_phone}`.trim() : "",
      s_email: info.s_email || "",
      s_address: info.s_address || info.locatedin || "",

      context_category_names: info.context_category_names || "",
      all_context_categories: info.context_category_names || "",

      s_desc: info.s_desc || "",
      s_images: Array.isArray(info.s_images) ? info.s_images : []
    };

    services.value = serviceInfo;

    // capture server business id for next calls
    apiBusinessId.value = info.slug || info.s_id || id;

    // Preload products if user clicks products tab later
    // (optional eager load here)
    // await loadVendorProducts();

  } catch (e) {
    console.error("businessdetail failed", e);
    business.value = {};
    apiBusinessId.value = "";
  } finally {
    loading.value = false;
  }
}

/* -------------------------
   Products API
------------------------- */
const categories = ref([]);
const products = ref([]);
const productsLoading = ref(false);
const selectedCategory = ref(null);
// refs already used above
const catTrack = ref(null);

// Show ALL products (across categories)
const allProducts = computed(() =>
  categories.value.flatMap((c) => c.products)
);
const allCount = computed(() => allProducts.value.length);

function showAllProducts() {
  selectedCategory.value = "All";
  products.value = allProducts.value;
}

// After loadVendorProducts() finishes building categories,
// set default to All (instead of first category)
async function loadVendorProducts() {
  if (!apiBusinessId.value) return;
  productsLoading.value = true;
  try {
    const fd = new FormData();
    fd.append("businessid", business.value.s_id);
    const res = await api.getVendorProducts(fd);

    const data = Array.isArray(res?.data?.data) ? res.data.data : [];

    categories.value = data.map((c, idx) => ({
      id: idx,
      name: c.categoryname,
      products: Array.isArray(c.products)
        ? c.products
            .filter((p) => p.hide !== "1")
            .map((p) => ({
              title: p.pname || "Product",
              image:
                p.image ||
                "https://dummyimage.com/600x400/eaeaea/aaa.png&text= NO+IMAGE ",
              price: p.price || "",
              description: p.description || "",
              currency: p.currency || "₹",
              hide: p.hide
            }))
        : [],
    }));

    // default to ALL
    showAllProducts();
  } catch (e) {
    console.error("getVendorProducts failed", e);
    categories.value = [];
    products.value = [];
  } finally {
    productsLoading.value = false;
  }
}

// Called when category in sidebar clicked
function filterByCategory(catName) {
  selectedCategory.value = catName;
  const cat = categories.value.find((c) => c.name === catName);
  products.value = cat ? cat.products : [];
}

/* -------------------------
   Computed bindings
------------------------- */
const businessName = computed(() => business.value.s_business || "Business");
const avatarUrl    = computed(() => business.value.s_user_img || "https://dummyimage.com/200x200/ccc/fff.png&text=LOGO");
const coverUrl     = computed(() => business.value.cover_img || business.value.banner_image || "https://dummyimage.com/1200x300/efefef/aaa.png");
const websiteHref  = computed(() => business.value.website || "");
const deliveryMethods = computed(() => business.value.deliverymethods);

const businessCategory = computed(() => `Business • ${business.value.businesscategory || "Category"}`);
const followers       = computed(() => business.value.followers || 0);
const locationText    = computed(() => business.value.city || "");
const openStatus      = computed(() => business.value.open_status || "");
const openInfo      = computed(() => business.value.open_info || "");

const phone   = computed(() => business.value.s_phone || "");
const email   = computed(() => business.value.s_email || "");
const address = computed(() => business.value.s_address || "");

const images = computed(() => {
  const arr = business.value.s_images || [];
  return arr.length;
});

const allCategoriesRaw = computed(() =>
  (business.value.context_category_names || "")
    .split(",")
    .map(s => s.trim())
    .filter(Boolean)
);

const selectedCategories = computed(() => allCategoriesRaw.value);
const allCategories = computed(() => services.value);

const aboutText = computed(() =>
  business.value.s_desc ||
  (selectedCategories.value.length
    ? `Welcome to ${businessName.value}. We offer ${selectedCategories.value.slice(0, 5).join(", ")} and more.`
    : `Welcome to ${businessName.value}.`)
);

const orderLink    = computed(() => business.value.orderonline_link || "");
const telegramLink = computed(() => business.value.telegram_link || "");
const whatsappLink = computed(() => business.value.whatsapp_link || "");

/* -------- Services: 2 columns, 4 per column per block (auto) ------- */
/**
 * Columnize with rule: fill left 4, right 4, then repeat for the remaining items.
 */
const leftServices = computed(() => {
  const src = selectedCategories.value;
  const left = [];
  let leftFill = true; // start with left block
  for (let i = 0; i < src.length; i += 8) {
    const block = src.slice(i, i + 8);
    // first 4 to left
    left.push(...block.slice(0, 4));
    // next 4 go to right (handled in rightServices)
    leftFill = !leftFill;
  }
  return left;
});

const rightServices = computed(() => {
  const src = selectedCategories.value;
  const right = [];
  for (let i = 0; i < src.length; i += 8) {
    const block = src.slice(i, i + 8);
    right.push(...block.slice(4, 8));
  }
  return right;
});

/* -------------------------
   Tabs + actions
------------------------- */
const tabs = [
  { key: "overview", label: "Overview" },
  { key: "products", label: "Products" },
  { key: "services", label: "Services" }
];
const currentTab = ref("overview");

/* load products only when user switches to products tab (lazy) */
watch(currentTab, (tab) => {
  if (tab === "products" && !products.value.length) {
    loadVendorProducts();
  }
});

/* reset to Overview if vendor changed */
watchEffect(() => {
  void business.value;
  currentTab.value = "overview";
});

function openLink(url) {
  if (!url) return;
  window.open(url, "_blank", "noopener");
}
function callPhone() {
  if (!phone.value) return;
  window.location.href = `tel:${phone.value.replace(/\s+/g, "")}`;
}
function sendEmail() {
  if (!email.value) return;
  window.location.href = `mailto:${email.value}`;
}

/* -------------------------
   Lifecycle + route changes
------------------------- */
onMounted(loadBusinessDetail);

onBeforeRouteUpdate((to) => {
  routeBusinessId.value = getBusinessIdFromRoute(to);
  loadBusinessDetail();
});
</script>


<style scoped>
.vendor-profile {
  border-radius: 12px;
}

/* Cover + avatar layout */
.cover-wrap {
  height: 180px;
  background: #f7f7f7;
}
.cover-img {
  height: 180px;
  object-fit: cover;
}
.avatar-img {
  position: absolute;
  left: 18px;
  bottom: -40px;
  width: 100px;
  height: 100px;
  border: 3px solid #fff;
  object-fit: cover;
}
.business-title {
  position: relative; 
  padding: 4px 0;
}

/* Horizontal button scroller */
.action-scroll {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  padding-bottom: 6px;
}
.action-scroll > .btn {
  white-space: nowrap;
  scroll-snap-align: start;
}
.action-scroll::-webkit-scrollbar {
  height: 6px;
}
.action-scroll::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,.12);
  border-radius: 4px;
}

.img-thumb-wrap {
    width:100%;
    height:200px;
}

.img-thumb-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Custom tabs */
.custom-tabs .tabs-bar {
  border-bottom: 1px solid #eee;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.tab-btn {
  background: transparent;
  border: 0;
  padding: 10px 14px;
  margin-right: 6px;
  font-weight: 600;
  color: #6c757d;
  position: relative;
  white-space: nowrap;
  outline: none;
}
.tab-btn.active {
  color: #111;
}
.tab-btn.active::after {
  content: "";
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: -1px;
  height: 2px;
  background: #007bff;
  border-radius: 2px;
}

.info-chip {
  border: 1px solid #e9ecef;
  background: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
}

.pill-wrap .badge-pill {
  font-weight: 500;
}

.sticky-sidebar {
  position: sticky;
  top: 80px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}

.category-list {
  max-height: 75vh;
  overflow-y: auto;
  margin: 0;
  padding: 0;
}

.category-item {
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
}

.category-item:hover,
.category-item.active {
  background-color: #007bff;
  color: #fff;
}

.text-truncate-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* horizontal scroll menu */
.cat-bar {
  position: relative;
}

.cat-track {
  display: flex;
  align-items: center;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 10px;
  padding-bottom: 6px;
  scrollbar-width: thin;
}

.cat-track::-webkit-scrollbar {
  height: 6px;
}
.cat-track::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,.15);
  border-radius: 4px;
}

.cat-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #d6e4ff;        /* light blue border */
  color: #1a73e8;                    /* google-ish blue */
  background: #fff;
  border-radius: 999px;
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
  transition: background-color .2s, color .2s, box-shadow .2s;
}

.cat-pill:hover { box-shadow: 0 2px 6px rgba(0,0,0,.06); }

.cat-pill.active {
  background: #1a73e8;
  color: #fff;
  border-color: #1a73e8;
}

.count-badge {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(26,115,232,.08);
  color: #1a73e8;
}
.cat-pill.active .count-badge {
  background: rgba(255,255,255,.25);
  color: #fff;
} 

.badge-danger {
    background-color: crimson!important;
}

/* Responsive tweaks */
@media (max-width: 576px) {
  .cover-wrap { height: 160px; }
  .cover-img { height: 160px; }
  .avatar-img { width: 64px; height: 64px; bottom: -22px; }
  .business-title { left: 92px; bottom: -10px; font-size: 1.05rem; }
}
</style>
